type Props = {
  orientation: 'horizontal' | 'vertical'
}

type Context = {
  active: boolean
  last: boolean
  index: number
}

type Parent = {
  props: Props
}

type State = { d_activeStep: number }

export default {
  root: ({ props }: { props: Props }) => ({
    class: ['flex-1', props.orientation === 'vertical' ? 'flex-col' : 'flex-row']
  }),
  nav: {
    class: [
      // Flexbox
      'flex',
      'justify-between',
      'items-center',

      // Spacing
      'm-0',
      'px-1',

      // Positioning
      'relative',

      // Lists
      'list-none',

      // Overflow
      'overflow-x-auto',

      'bg-[var(--card-light)] dark:bg-[var(--card-lighter)] rounded-3xl'
    ]
  },
  stepperpanel: {
    panel: ({
      context,
      parent
    }: {
      context: Context
      parent: Parent
    }) => ({
      class: [
        context.active ? 'flex-1' : '',
        parent.props.orientation === 'vertical' ? 'flex flex-col flex-initial' : ''
      ]
    }),
    header: ({ parent, context }: {
      context: Context
      parent: Parent
    }) => ({
      class: [
        // Position
        'relative',

        // Flexbox
        'flex',
        'items-center',
        context.last ? 'flex-initial' : 'flex-1',
        parent.props.orientation === 'vertical' ? 'flex-initial' : '',

        // Spacing
        'p-2'
      ]
    }),
    action: {
      class: [
        // Borders
        'border-0',
        'border-none',

        // Flexbox
        'inline-flex',
        'items-center',

        // Text
        'text-decoration-none',

        // Transitions
        'transition',
        'transition-shadow',
        'duration-200',

        // Shape
        'rounded-md',

        // Backgrounds
        'bg-transparent',

        // Focus
        'outline-none',
        'cursor-default'
      ]
    },
    number: ({ context, state }: { context: Context, state: State }) => ({
      class: [
        // Flexbox
        'flex',
        'items-center',
        'justify-center',

        //Colors

        // Colors (Conditional)
        context.active ? 'font-bold' : '', // Adjust colors as needed
        state.d_activeStep === context.index ? 'bg-primary text-white' : 'text-slate-900 dark:text-[var(--white-80)] bg-white dark:bg-secondary',

        // Size and Shape
        'min-w-[2rem]',
        'h-[2rem]',
        'line-height-[2rem]',
        'rounded-full',

        // Text
        'text-lg',

        // Transitions
        'transition',
        'transition-colors',
        'transition-shadow',
        'duration-200'
      ]
    }),
    title: () => ({
      class: [
        // Layout
        'block',
        'whitespace-nowrap',
        'overflow-hidden',
        'text-ellipsis',
        'max-w-full',

        // Spacing
        'ml-2',

        // Text
        // context.active ? 'text-primary' : 'text-slate-700 -dark:text-white/80',
        'text-slate-900 dark:text-[var(--white-80)]',
        'font-medium',

        // Transitions
        'transition',
        'transition-colors',
        'transition-shadow',
        'duration-200'
      ]
    }),
    separator: ({ context, state, parent }: {
      context: Context
      state: State
      parent: Parent

    }) => ({
      class: [
        // Colors (Conditional for active step)
        state.d_activeStep <= context.index ? '-dark:bg-slate-200/30 bg-slate-700/60' : 'bg-primary',

        // Conditional for Vertical Orientation
        parent.props.orientation === 'vertical'
          ? ['flex-none', 'w-[2px]', 'h-auto', 'ml-[calc(1.29rem+2px)]']
          : ['flex-1', 'w-full', 'h-[2px]', 'ml-4'],

        // Transitions
        'transition-shadow',
        'duration-200'
      ]
    }),
    transition: {
      class: [
        'flex flex-1',
        'bg-white dark:bg-slate-900',
        'text-slate-900 dark:text-white',
        'py-4 pr-4',
        'rounded-md'
      ],
      enterFromClass: 'max-h-0',
      enterActiveClass:
        'overflow-hidden transition-[max-height] duration-1000 ease-[cubic-bezier(0.42,0,0.58,1)]',
      enterToClass: 'max-h-[1000px]',
      leaveFromClass: 'max-h-[1000px]',
      leaveActiveClass:
        'overflow-hidden transition-[max-height] duration-[450ms] ease-[cubic-bezier(0,1,0,1)]',
      leaveToClass: 'max-h-0'
    },
    content: ({ parent }: { parent: Parent }) => ({
      class: [parent.props.orientation === 'vertical' ? 'w-full pl-4' : '']
    })
  },
  panelcontainer: {
    class: [
      // Colors
      'bg-white dark:bg-slate-900',
      'text-slate-900 dark:text-white',
      'border border-slate-200 dark:border-none',

      // Spacing
      'mt-2',
      'p-4',
      'rounded-md'
    ]
  }
}
